/**
 * DR Vitamin — keep the header's place when it turns sticky (2026-09-16 optimization program, CLS fix).
 *
 * theme.js (Megamenu.sticky) fixes .header-top (phone) / .navigationMenu (desktop) to the viewport once the page scrolls
 * past them, and then tries to hold their space with header.style.setProperty('min-height', stickyHeight). That value is
 * a bare number without a unit, so the browser drops it: <header> collapsed (phone 128 px → 1 px, desktop 172 → 121) and
 * the whole page jumped up, then down again on the way back (layout shift 0.15 each way on a phone).
 *
 * This holds the same space on <header> with a valid length. The sticky bar itself looks and moves exactly as before;
 * nothing of the theme's header code, and nothing of the contact launcher, is changed.
 * Natural height = <header>'s in-flow height + the in-flow height of each part that is currently fixed.
 */
(function () {
  'use strict';
  var header = document.querySelector('header');
  if (!header) return;
  var PARTS = '.header-top, .navigationMenu, .header-fixed';
  var inFlow = typeof WeakMap === 'function' ? new WeakMap() : null;

  function measure() {
    header.style.minHeight = '';
    var h = header.getBoundingClientRect().height;
    var parts = header.querySelectorAll(PARTS);
    for (var i = 0; i < parts.length; i += 1) {
      var el = parts[i];
      var fixed = getComputedStyle(el).position === 'fixed';
      var own = el.getBoundingClientRect().height;
      if (!fixed) { if (inFlow) inFlow.set(el, own); continue; }
      /* a fixed part no longer takes space: add back the height it had in the page (it loses a border when fixed) */
      h += (inFlow && inFlow.has(el)) ? inFlow.get(el) : own;
    }
    h = Math.round(h);
    if (h > 0) header.style.minHeight = h + 'px';
  }

  measure();
  window.addEventListener('load', measure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  var t;
  function later(ms) { clearTimeout(t); t = setTimeout(measure, ms); }
  window.addEventListener('resize', function () { later(120); });
  if ('ResizeObserver' in window) {
    /* the header's own content can change height (a font swap, the language row); a sticky toggle keeps the natural
       height the same, so re-measuring then changes nothing */
    var ro = new ResizeObserver(function () { later(60); });
    var parts = header.querySelectorAll(PARTS);
    for (var i = 0; i < parts.length; i += 1) ro.observe(parts[i]);
  }
})();
